import { render, staticRenderFns } from "./MyNewsletter.vue?vue&type=template&id=098cec0c&"
import script from "./MyNewsletter.vue?vue&type=script&lang=js&"
export * from "./MyNewsletter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports